<template>
	<div>
		<!-- Start of grid -->
		<div v-for="(row, rowIndex) in page.grid" :key="rowIndex" class="row">
			<div v-for="(col, colIndex) in row" :key="colIndex" v-bind:class="getColClass(col)">
			<!-- Start of grid -->

				<div v-for="(field, fieldIndex) in col.fields" :key="fieldIndex">
					<input type="hidden" name="field_id" v-bind:value="field.id" />
					<FormField :field="field" :type="field.type" :readonly="readonly" :viewAs="viewAs" :formresponse="formresponse"></FormField>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import FormField from "../FormField";
export default {
	components: {
		FormField
	},
	name: 'FormGrid',
	props: ['page','readonly', 'viewAs', 'formresponse'],
	methods: {
		getColClass(col){
			return 'col-md-' + col.width;
			// style="border: 1px dashed #EEE; padding: 10px 10px;"
		}
	}
};
</script>
